import team from './team';
import events from './events';
import { positions } from './career';
import services from './services';
import portfolio from './portfolio';
import products from './products';
import blogs from './blogs';
import cars from './cars';
import dealers from './dealers';


const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-us', title: 'about us'},
            {id: 2, link: '/Team', title: 'team'},
            {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
            {id: 4, link: '/Testimonials', title: 'testimonials'},
            {id: 5, link: '/Faqs', title: 'faqs'},
            {id: 6, link: '/Awards', title: 'Awards'},
            {id: 7, link: '/Partners', title: 'Partners'},
        ],
    },
    {
        id: 3,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
          {
            id: 1,
            title: "Service",
            children: [
              { id: 1, title: "Services", link: "/Services" },
              { id: 2, title: "Service Single", link: "/Services/ServiceSingle", state: services[0] },
            ],
          },
          {
            id: 2,
            title: "Portfolio",
            children: [
              { id: 1, title: "Portfolio", link: "/Portfolio" },
              { id: 2, title: "Portfolio Single", link: "/Portfolio/PortfolioSingle",  state: portfolio[0] },
            ],
          },
          {
            id: 3,
            title: "Career",
            children: [
              { id: 1, title: "Careers", link: "/Careers" },
              { id: 2, title: "Career Single", link: "/Careers/CareerSingle", state: positions[0] },
              { id: 3, title: "Career Form", link: "/CareerForm" },
            ],
          },
          {
            id: 4,
            title: "Event",
            children: [
              { id: 1, title: "Events", link: "/Events" },
              { id: 2, title: "Event Single", link: "/Events/EventSingle", state: events[0] },
            ],
          },
          { id: 5, title: "Gallery", link: "/Gallery" },
          { id: 6, title: "Features", link: "/Features" },
          { id: 7, title: "Pricing", link: "/Pricing" },
          {
            id: 8,
            title: "Company Policy",
            children: [
              { id: 1, title: "Error 404", link: "/Error" },
              { id: 2, title: "Terms of Services", link: "/ServiceTerms" },
              { id: 3, title: "Privacy Policy", link: "/PrivacyPolicy" },
            ],
          },
          { id: 9, title: "Calculator", link: "/LoanCalculator" },
          { id: 10, title: "Work Process", link: "/WorkProcess" },
          { id: 11, title: "Support Center", link: "/Support" },
        ],
    },
    {
        id: 4,
        mainLink : {link: '#', title: 'Cars'},
        subLink: [
            {id: 1, link: '/Car-Grid', title: 'car grid'},
            {id: 2, link: '/Car-List', title: 'car list'},
            {id: 3, link: '/Cars/Car-Single', title: 'car single', state: cars[0]}, 
            {id: 4, link: '/CarCompare', title: 'Car Compare'},
            {id: 5, link: '/GetQuote', title: 'Get A Quote'},
            {id: 6, link: '/SellCar', title: 'Sell Your Car'},
        ],
    },
    {
        id: 5, 
        mainLink : {link: '#', title: 'Dealer'},
        subLink: [
            {id: 1, link: '/Dealers', title: 'Dealers'},
            {id: 2, link: '/Dealers/DealerSingle', title: 'Dealer Single', state: dealers[0]}, 
        ],
    }, 
    {
        id: 6,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 7,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;